import { FC } from "react";
import { ICardSwitchProps } from "./types";
import SwitchCarma from "../Switch/Switch";
import Button from "../Button/Button";
import { TrashIcon } from "../icons/TrashIcon";
import BrandLogo from "../BrandLogo/BrandLogo";
import { UpgradePlanButton } from "../UpgradePlanButton";
import classNames from "classnames";
import styles from "./CardSwitch.module.css";

const CardSwitch: FC<ICardSwitchProps> = ({
  title,
  caption,
  active = true,
  deleteable = true,
  icon: Icon,
  logoUrl,
  onDelete,
  onSwitchChange,
  id,
  isPlanLocked = false,
  onUpgrade,
}) => {
  const handleClick = () => {
    onDelete?.(id);
  }

  const handleSwitchChange = (value: boolean) => {
    if (isPlanLocked) return;
    onSwitchChange(id, value);
  }

  return (
    <article
      className={classNames(
        styles["card-switch"],
        !active && styles["is-disabled"],
        isPlanLocked && styles["is-plan_locked"],
      )}
    >
      <div className={styles["card-switch__header"]}>
        {Icon && <div className={styles["card-switch__icon"]}>
          <Icon />
        </div>}
        <div className={styles["card-switch__content"]}>
          <h2 className={styles["card-switch__title"]}>
            {logoUrl && (
              <BrandLogo 
                logoUrl={logoUrl} 
                name={title} 
                size="small"
                className={styles["card-switch__logo"]}
              />
            )}
            {title}
          </h2>
          {caption && <p className={styles["card-switch__caption"]}>{caption}</p>}
        </div>
        {!active && deleteable && <Button
          onClick={handleClick}
          className={styles["card-switch__delete"]}
          typeStyle="round"
          Icon={TrashIcon}
        />}
      </div>
      <div className={styles["card-switch__actions"]}>
        {isPlanLocked ? (
          <UpgradePlanButton onUpgrade={onUpgrade} />
        ) : (
          <>
            {active && <p>Active</p>}
            <SwitchCarma isChecked={active} onChange={handleSwitchChange} />
          </>
        )}
      </div>
    </article>
  );
};

export default CardSwitch;
